import * as moment from "moment";

export const SiteNumberFilterMember = "SiteNumber";
export const SubjectNumberFilterMember = "SubjectNumber";
export const SubjectRandomizationNumberFilterMember = "RandomisedId";
export const SubjectRandomizationStatusFilterMember = "RandomisedStatus";
export const SubjectFirstNameFilterMember = "FirstName";
export const SubjectMiddleNameFilterMember = "MiddleName";
export const SubjectLastNameFilterMember = "LastName";
export const SubjectDateOfBirthFilterMember = "BirthDate";
export const SubjectAgeFilterMember = "Age";
export const SubjectGenderFilterMember = "Gender.Id";
export const SubjectHeightFilterMember = "Height";
export const SubjectWeightFilterMember = "Weight";
export const SubjectPopulationGroupFilterMember = "PopulationGroupName";
export const SubjectSmokingStatusFilterMember = "SmokerType.Name";
export const SubjectTerminationDateFilterMember = "TerminationDate";
export const SubjectRandomizationDateFilterMember = "RandomisedDateTime";

export interface SubjectFormModel {
    Id: string;
    StudyId: string;
    SiteNumber: string;
    SiteId: string;
    SubjectNumber: string;
    GenderId: string;
    Age: number;
    SubjectTypeId: string;
    
    PopulationGroupId: string;
    SmokerTypeId: string;
    BirthDate: string;
    Height: number;
    Weight: number;
    BMI: number;
    LanguageId: string;
    Pin: string;
    PinConfirmation: string;
    BedTime: string;
    Alarms: string[];
    Race: string;
}

export const ExtractDefaultAlarms = (alarmString: string): string[] => {
    let alarmTimes: string[] = null;
    if (alarmString !== undefined) {

        const alarmTimeStrings = alarmString.slice(1, -1).split(',');

        alarmTimes = alarmTimeStrings.map((timeString: string) => {
            const [hours, minutes] = timeString.split(':');
            return moment.duration(`${hours}:${minutes}`).format("hh:mm:ss");
        });
    }

    return alarmTimes?.map(alarm => alarm) ?? null;
}
